export const CrossImage = () => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.804 1.61199C14.9533 1.76131 14.9533 2.0034 14.804 2.15272L2.56873 14.388C2.41941 14.5373 2.17732 14.5373 2.028 14.388C1.87869 14.2387 1.87869 13.9966 2.028 13.8473L14.2633 1.61199C14.4126 1.46267 14.6547 1.46267 14.804 1.61199Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.028 1.61199C2.17732 1.46267 2.41941 1.46267 2.56873 1.61199L14.804 13.8473C14.9533 13.9966 14.9533 14.2387 14.804 14.388C14.6547 14.5373 14.4126 14.5373 14.2633 14.388L2.028 2.15272C1.87869 2.0034 1.87869 1.76131 2.028 1.61199Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.804 1.61199C14.9533 1.76131 14.9533 2.0034 14.804 2.15272L2.56873 14.388C2.41941 14.5373 2.17732 14.5373 2.028 14.388C1.87869 14.2387 1.87869 13.9966 2.028 13.8473L14.2633 1.61199C14.4126 1.46267 14.6547 1.46267 14.804 1.61199Z"
        stroke="#A0A09B"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.028 1.61199C2.17732 1.46267 2.41941 1.46267 2.56873 1.61199L14.804 13.8473C14.9533 13.9966 14.9533 14.2387 14.804 14.388C14.6547 14.5373 14.4126 14.5373 14.2633 14.388L2.028 2.15272C1.87869 2.0034 1.87869 1.76131 2.028 1.61199Z"
        stroke="#A0A09B"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
